import http from '@/common/request/axios';

export const gameService = {
    report: {
        get() {
            return http.doGet('/admin/game/report');
        },

        update(warningThreshold: any, penaltyThreshold: any, penaltyGame: any) {
            return http.doPut('/admin/game/report', {
                warningThreshold: warningThreshold,
                penaltyThreshold: penaltyThreshold,
                penaltyGame: penaltyGame
            });
        },

        remove() {
            return http.doDelete('/admin/game/report');
        }
    },

    parameter: {
        get() {
            return http.doGet('/admin/game/parameter');
        },

        update(
            phaseNames: any,
            phaseTimes: any,
            botPayPercent: any,
            botPlayableTime: any,
            betRange: any,
            rankBoostCharge: any,
            rankBoostRejectLimit: any,
            lobbyLimitTable: any
        ) {
            return http.doPut('/admin/game/parameter', {
                phaseNames: phaseNames,
                phaseTimes: phaseTimes,
                botPayPercent: botPayPercent,
                botPlayableTime: botPlayableTime,
                betRange: betRange,
                rankBoostCharge: rankBoostCharge,
                rankBoostRejectLimit: rankBoostRejectLimit,
                lobbyLimitTable: lobbyLimitTable
            });
        },

        remove() {
            return http.doDelete('/admin/game/parameter');
        }
    },

    variant: {
        list() {
            return http.doGet('/admin/game/variant');
        },

        get(id: string) {
            return http.doGet('/admin/game/variant/' + id);
        },

        create(id: any, name: any, minPlayer: any, maxPlayer: any, hasTeam: any) {
            return http.doPost('/admin/game/variant', {
                id: id,
                name: name,
                minPlayer: minPlayer,
                maxPlayer: maxPlayer,
                hasTeam: hasTeam
            });
        },

        enable(id: string) {
            return http.doPut('/admin/game/variant/' + id + '/enable');
        },

        disable(id: string) {
            return http.doPut('/admin/game/variant/' + id + '/disable');
        },

        remove(id: string) {
            return http.doDelete('/admin/game/variant/' + id);
        },

        getText(id: string, locale: string) {
            return http.doGet('/admin/game/variant/' + id + '/text/' + locale);
        },

        updateText(id: string, locale: string, title: any) {
            return http.doPut('/admin/game/variant/' + id + '/text/' + locale, {
                title: title
            });
        },

        removeText(id: string, locale: string) {
            return http.doDelete('/admin/game/variant/' + id + '/text/' + locale);
        }
    },

    match: {
        list({ variantId }: any = {}) {
            return http.doGet('/admin/game/match', { variantId });
        },

        get(id: any) {
            return http.doGet('/admin/game/match/' + id);
        },

        create(
            variantId: any,
            name: any,
            type: any,
            maxRound: any,
            maxPoint: any,
            levelTimeout: any,
            findingMatchTimeout: any,
            winLoseGroup: any,
            allowInvitation: any,
            tableCreditRatio: any,
            costs: any,
            costStates: any,
            potRatePercents: any,
            potRateWeights: any
        ) {
            return http.doPost('/admin/game/match', {
                variantId,
                name,
                type,
                maxRound,
                maxPoint,
                levelTimeout,
                findingMatchTimeout,
                winLoseGroup,
                allowInvitation,
                tableCreditRatio,
                costs,
                costStates,
                potRatePercents,
                potRateWeights
            });
        },

        update(
            id: any,
            name: any,
            levelTimeout: any,
            findingMatchTimeout: any,
            winLoseGroup: any,
            allowInvitation: any,
            costs: any,
            costStates: any,
            potRatePercents: any,
            potRateWeights: any
        ) {
            return http.doPut('/admin/game/match/' + id, {
                name,
                levelTimeout,
                findingMatchTimeout,
                winLoseGroup,
                allowInvitation,
                costs,
                costStates,
                potRatePercents,
                potRateWeights
            });
        },

        remove(id: any) {
            return http.doDelete('/admin/game/match/' + id);
        }
    }
};
